module.exports = __webpack_public_path__ + "static/rockshop-32de461e9f0f260b9a31ee6aad9219cd.png";